<template>
    <v-card>
        <v-card-title>
            <v-title>Manage Kayako Notes</v-title>
        </v-card-title>
        <v-card-text>
            <v-layout wrap>
                <v-flex xs3>
                    <v-text-field
                            name="Search"
                            label="Please Enter Ticket ID"
                            v-model="search"
                    ></v-text-field>
                </v-flex>
                <v-flex >
                    <v-btn color="primary" @click="GetKayakoNotes">Search</v-btn>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-text>
            <div style="height: 100%">
                <v-progress-linear
                        v-if="tableLoading"
                        indeterminate
                        color="primary"
                ></v-progress-linear>
                <ag-grid-vue
                        domLayout="autoHeight"
                        class="ag-theme-balham"
                        :columnDefs="columnDefs"
                        :rowData="rowData"
                        :defaultColDef="defaultColDef"
                        :frameworkComponents="frameworkComponents"
                        @first-data-rendered="onFirstDataRendered"
                        @grid-ready="onGridReady"
                        pagination
                        :paginationPageSize="10"
                ></ag-grid-vue>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import { HTTP } from "@/http-common";
    import axios from "axios";
    import { AgGridVue } from "ag-grid-vue";
    import KayakoTableButtons from "@/components/kayako-table-buttons";
    import {createNamespacedHelpers} from "vuex";
    const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
    export default {
        name: "manage-kayako",
        components:{
            AgGridVue,
            KayakoTableButtons
        },
        data () {
            return {
                search: "",
                columnDefs: [],
                rowData:[],
                tableLoading:false,
                gridApi:null,
                columnApi:null,
                frameworkComponents: null,
            }
        },
        beforeMount() {
            let vm = this
            vm.setColumnDefs();
            vm.defaultColDef = {
                resizable: true,
                autoHeight: true,
                autoLineWidth: true,
            };
            vm.frameworkComponents = {
                kayakoTableButtons: KayakoTableButtons,
            };
        },
        methods: {
            ...mapOrderActions(["getKayakoNotes", "deleteKayakoNote"]),
            GetKayakoNotes() {
                this.tableLoading = true;
                var ticketNo = this.search;
                let vm = this;
                vm.getKayakoNotes(ticketNo).then(result => {
                    vm.rowData = result;
                    vm.tableLoading = false;
                });
            },
            onGridReady(params) {
                this.gridApi = params.api;
                this.columnApi = params.columnApi;
                params.api.sizeColumnsToFit();
            },
            setColumnDefs() {
                let vm = this;
                vm.columnDefs = [
                    { headerName: "Id", field: "id",},
                    { headerName: "Note", field: "text",},
                    { headerName: "ConversationId", field: "conversationId",},
                    { headerName: "Note Type", field: "noteUrl",
                        valueFormatter: (param) => {
                            if(param.value.toString().includes("cases"))
                            {
                                return "Conversation Note"
                            } else if(param.value.toString().includes("users")) 
                            {
                                return "User Note"
                            } else if(param.value.toString().includes("organizations"))
                            {
                                return "Organization Note"
                            }
                        },
                    },
                    {headerName: "Action", 
                        field:"action",
                        cellRenderer: "kayakoTableButtons",
                        cellRendererParams: {
                            clicked: function (param) {
                                if(param === true)
                                {
                                    vm.GetKayakoNotes();
                                }
                            },
                        },
                    }
                ];
                // vm.gridApi.sizeColumnsToFit();
            },
            onFirstDataRendered (grid) {
                grid.api.sizeColumnsToFit();
            },
        }
    }
</script>

<style scoped>

</style>